<!-- app/javascript/.../UpdateBanner.vue -->
<script>
export default { name: 'UpdateBanner' };
</script>

<template></template>

<style scoped></style>
